<template>
<div>

            <!-- COMPONENTE PARA EL REGISTRO DE PERSONAS FISICAS Y MORALES PARA EL ENVIO DEL CANAL DIGITAL -->
            <div class="p-4 md:p-6 shadow bg-gray2 max-w-4xl   mx-auto my-0">
                <h1 class="text-lg font-medium sm:text-2xl pb-4 ">Solicitud de arrendamiento digital.</h1>
                                <div class="flex" :class="step == 1 ? 'cursor-pointer' : 'cursor-default'" @click="showSection()"  >

                        <div>
                            <div
                                class="rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium"
                                :class="[formComplete ? ['bg-white'] : ['bg-light-blue', 'text-white']]"
                            >{{ step == 1 ? 1 : 2 }}</div>
                        </div>
                        <div
                            class="ml-4"
                            :class="formComplete ? 'text-white' : ''"
                        >
                            <p v-if="step == 1" class="text-lg sm:text-2xl font-medium leading-none xs:leading-tight pb-4">Registro de información de solicitante.</p> 
                        </div>
                        <div class="ml-auto mt-2">
            
                        </div>
            </div>


                <!--Select para mostrar si la persona es física o moral  -->
                <div  v-if="step == 1" class="text-center w-full">
                    <p class="  text-2xl  font-bolder pb-2">Selecciona el tipo de Régimen Fiscal: </p>
                    <select class="text-2xl pt-2"   @change="showForms($event)" name="persona" id="persona">
                        <option value="Física">Selecciona una opción</option>
                        <option  value="physical">Física</option>
                        <option  value="legal">Moral</option>
                    </select>
                </div>
                    <!--Componente para el registro de  persona fisica o moral -->
                <div v-if="step == 2 && showDigitalChannel == false" >
                    <a class="cursor-pointer pb-2" @click="step = 1">
                    <i
                        class="border-solid border-black inline-block p-1 mr-1"
                        style="border-width: 0 2px 2px 0; transform: rotate(135deg);"
                    />
                    <p class="inline-block text-sm pb-2">Regresar</p>
                    </a>   
                        <abc-persons-form 
                        :activities="activities" 
                        :formType="type"
                        @add-person="addPerson"
                        >
                            
                        </abc-persons-form>
                </div>
                <!-- Formulario para registrar un aval si se selecciono a  una persona moral -->
                <div v-if="step == 3 && showDigitalChannel == false">
                    A continuación será necesario el registro de un aval.
                    <abc-aval-person
                        :activities="activities" 
                        @add-person="addPerson"
                        >
                    </abc-aval-person>
                </div>
                <!-- Mensaje del canal digital y boton para la reedireción -->
                <div class="justify-center " v-if="digitalChannelResponse != ''">
                    <p class=" text-center  text-2xl ">
                        {{ digitalChannelResponse }}
                    </p>
                    <a 
                    class="hyundai-button-gray sm:text-base mx-auto mt-2"
                        target="blank"
                       :href="`${url}/${webpage}/contacto`"
                    > Solicitar asesoria</a>

                </div>
            </div>


           

</div>



</template>

<script>
import AbcInsuranceSelection from './AbcInsuranceSelection.vue'
import Swal from "sweetalert2";

export default {
  components: { AbcInsuranceSelection },
  props:[
    'abcQuotationData'
  ],

    data(){
        return{
            url: $(".url").text(),
            webpage: $(".webpage").text(),
            type:'',
            //Arreglo para mostrar los tipos de actividades economicas
            activities:[],
            //Objeto donde almacenaremos los datos de la persona fisica o moral
            persons:{
                physicPersons:[],
                legalPersons:[]
            },
            //variables para mostrar u ocultar los componentes
            showForm:false,
            showFormSection:true,
            formComplete:false,
            showLoader:false,
            showResponse:false,
            showAval:false,
            showDigitalChannel:false,
            //Variable para guardar la respuesta de la petición de DigitalChannel
            digitalChannelResponse:'',
            step: 1,

            
            
        }
    },


    methods :{
        //Metodo para guardar las aseguradoras
        getInsurer(insurer){
            this.insurer = insurer

        },

        //Metodo para almacenar a una persona fisica o una legal
        addPerson(formData){
            //Si es tipo 1 se guardara una persona fisica
            if(formData.type === 1){
                this.persons.physicPersons.push(formData.data)
                this.showAval = false
                this.showDigitalChannel=true
                //Se realiza el envio al controlador para ver la respuesta del canal digital
                this.sendDigitalChanel()

            } else{
                //Si es tipo 2 se registrara una persona legal
                this.persons.legalPersons.push(formData.data)
                //Siempre que se seleccione una persona legal debe de registrarse a una persona fisica como aval
                //Esto se realiza  en el formulario de aval cargandolo en la siguiente linea
                this.showAval=true
                this.step = 3
            }
            //Una vez concluido el registro se oculta el componente
          this.showForm=false
          this.showFormSection=false

        },
        //Metodo para cargar las Actividades economicas que vienen desde ABC
        showForms: function(event){
            console.log('Activado PErsona', event);
            // ajuste de ruta en solicitud par alamacenar datos.
            axios.get(`${this.url}/abc/abcChargeActivities`)
            .then((res)=>{
                this.activities = res.data.activities
                this.showForm = true
                this.step = 2
                this.type=event.target.value
                this.showFormSection=false


            })
        },
        //Metodo para hacer el envio del canal digital enviando las personas fisicas y morales y la cotización del vehículo
        sendDigitalChanel(){
                this.showLoader = true
                console.log(this.persons)
                console.log(this.abcQuotationData)
                //Se crea una clave para las personas  y otra para la cotizacion
                const formData ={
                    'persons' :this.persons,
                    'quotation' :this.abcQuotationData
                }
                axios.post(`${this.url}/abc/digitalChannel`, formData )
                .then((res)=>{
                    //Si el envio fue exitoso se guarda la respuesta para mostrarla posteriormente
                    this.digitalChannelResponse = res.data.data.message
                    
                    
                })
                .catch((error)=>{
                    this.showLoader = false
                })

        }
    }

}
</script>

<style>

</style>